import { render, staticRenderFns } from "./ListOfChats.vue?vue&type=template&id=14010c5a&scoped=true&"
import script from "./ListOfChats.vue?vue&type=script&lang=js&"
export * from "./ListOfChats.vue?vue&type=script&lang=js&"
import style0 from "./ListOfChats.vue?vue&type=style&index=0&id=14010c5a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14010c5a",
  null
  
)

export default component.exports